import React, { useEffect, useState, useContext } from "react";
import QRCode from "qrcode.react";
import toastError from "../../errors/toastError";
import { makeStyles } from "@material-ui/core/styles";
import { Dialog, DialogContent, Paper, Typography, Box, Divider } from "@material-ui/core";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import qrScanImg from "../QrcodeModal/qr_scan.png";

import { AuthContext } from "../../context/Auth/AuthContext";

const useStyles = makeStyles((theme) => ({
  dialog: {
    padding: theme.spacing(3),
    borderRadius: "16px",
  },
  root: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  instructions: {
    flex: 1,
    paddingRight: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      paddingRight: 0,
      marginBottom: theme.spacing(3),
      textAlign: "center",
    },
  },
  qrContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(3),
    backgroundColor: "#f9fbff",
    borderRadius: "20px",
    boxShadow: "0 8px 32px rgba(0,0,0,0.05)",
    border: "1px solid #eef2f6",
  },
  stepNumber: {
    backgroundColor: theme.palette.primary.main,
    color: "#white",
    width: 24,
    height: 24,
    borderRadius: "50%",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: theme.spacing(1),
    fontSize: "14px",
    fontWeight: "bold",
    color: "white"
  },
  stepItem: {
    display: "flex",
    alignItems: "flex-start",
    marginBottom: theme.spacing(2),
  }
}));

const QrcodeModal = ({ open, onClose, whatsAppId }) => {
  const classes = useStyles();
  const [qrCode, setQrCode] = useState("");
  const { user, socket } = useContext(AuthContext);

  useEffect(() => {
    const fetchSession = async () => {
      if (!whatsAppId) return;

      try {
        const { data } = await api.get(`/whatsapp/${whatsAppId}`);
        setQrCode(data.qrcode);
      } catch (err) {
        toastError(err);
      }
    };
    fetchSession();
  }, [whatsAppId]);

  useEffect(() => {
    if (!whatsAppId) return;
    const companyId = user.companyId;

    const onWhatsappData = (data) => {
      if (data.action === "update" && data.session.id === whatsAppId) {
        setQrCode(data.session.qrcode);
      }

      if (data.action === "update" && data.session.qrcode === "") {
        onClose();
      }
    }
    socket.on(`company-${companyId}-whatsappSession`, onWhatsappData);

    return () => {
      socket.off(`company-${companyId}-whatsappSession`, onWhatsappData);
    };
  }, [whatsAppId, onClose]);

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="md" 
      fullWidth
      PaperProps={{
        style: { borderRadius: "16px", padding: "10px" }
      }}
    >
      <DialogContent>
        <Box className={classes.root}>
          {/* Lado Esquerdo: Instruções */}
          <div className={classes.instructions}>
            <Box display="flex" alignItems="center" marginBottom={2}>
              <img 
                src={qrScanImg} 
                alt="QR Scan" 
                style={{ width: "80px", marginRight: "16px" }} 
              />
              <Typography variant="h5" style={{ fontWeight: 700, color: "#333" }}>
                Conectar WhatsApp
              </Typography>
            </Box>
            
            <Typography variant="body1" color="textSecondary" style={{ marginBottom: 24 }}>
              Siga os passos abaixo para vincular sua conta e começar a enviar mensagens:
            </Typography>

            <div className={classes.stepItem}>
              <span className={classes.stepNumber}>1</span>
              <Typography variant="body2" style={{ fontWeight: 500 }}>
                Abra o WhatsApp no seu celular.
              </Typography>
            </div>
            
            <div className={classes.stepItem}>
              <span className={classes.stepNumber}>2</span>
              <Typography variant="body2" style={{ fontWeight: 500 }}>
                Toque em <b>Mais Opções</b> ou <b>Configurações</b> e selecione <b>Dispositivos Conectados</b>.
              </Typography>
            </div>

            <div className={classes.stepItem}>
              <span className={classes.stepNumber}>3</span>
              <Typography variant="body2" style={{ fontWeight: 500 }}>
                Toque em <b>Conectar um Dispositivo</b> e aponte seu celular para o QR Code ao lado.
              </Typography>
            </div>
          </div>

          {/* Lado Direito: QR Code */}
          <div className={classes.qrContainer}>
            {qrCode ? (
              <>
                <Box style={{ backgroundColor: "white", padding: "15px", borderRadius: "12px", border: "1px solid #e0e6ed" }}>
                  <QRCode value={qrCode} size={250} level="H" />
                </Box>
                <Typography variant="caption" style={{ marginTop: 12, color: "#666", fontWeight: 500 }}>
                  O código expira em breve. Mantenha a tela ativa.
                </Typography>
              </>
            ) : (
              <Box display="flex" flexDirection="column" alignItems="center">
                <Typography variant="body2" color="textSecondary">
                  Aguardando pelo QR Code...
                </Typography>
                {/* Simulação de loading se necessário */}
              </Box>
            )}
          </div>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default React.memo(QrcodeModal);
